import requestMagicLink from 'src/dataLayer/remoteData/babbelAPI/requestMagicLink';
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';

export default function useMagicLinkRequest({ captchaResponseToken, email }) {
    const { locale } = useRouteParamsContext();
    const {
        makeRequest,
        inProgress
    } = useAsyncData(() => requestMagicLink({ captchaResponseToken, email, locale }));

    return {
        makeMagicLinkRequest: makeRequest,
        isMagicLinkRequestInProgress: inProgress
    };
};
